import { useEffect, useState } from 'react';
import { capitalize, months } from '../../libraries/utils';

function BirthDateInput({ input, meta, label, options, empty, ...rest }) {

  // ❌ ya no usamos today como default
  const years = [...Array(new Date().getFullYear() - 1899).keys()].map(x => {
    const year = new Date().getFullYear() - x;
    return { label: year, value: year };
  });

  const months_arr = [...Array(12).keys()].map(x => ({
    label: capitalize(months(x).slice(0, 3)),
    value: x
  }));

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const [selectedDate, setSelectedDate] = useState(null);
  const [invalidDate, setInvalidDate] = useState(false);

  // 👉 SOLO setea valores si viene algo desde afuera
  useEffect(() => {
    
    if (input.value && input.value !== "") {
      const fecha = new Date(input.value);
      setDay(fecha.getDate());
      setMonth(fecha.getMonth());
      setYear(fecha.getFullYear());
    } else {
      setDay("");
      setMonth("");
      setYear("");
      setSelectedDate(null);
    }
  }, []);

  // 👉 validar fecha
  useEffect(() => {
    if (day && month !== "" && year) {
      try {
        const d = new Date(year, month, day);
        const valid =
          d.getFullYear() === year &&
          d.getMonth() === month &&
          d.getDate() === day;

        if (valid) {
          setSelectedDate(d);
          setInvalidDate(false);
        } else {
          setSelectedDate(null);
          setInvalidDate(true);
        }
      } catch (e) {
        setSelectedDate(null);
        setInvalidDate(true);
      }
    } else {
      setSelectedDate(null);
      setInvalidDate(false);
    }
  }, [day, month, year]);

  // 👉 propagar cambio
  useEffect(() => {
    input.onChange(selectedDate);
  }, [selectedDate]);

  return (
    <div className={"form-control w-full max-w-xs " + (rest.className || "")}>

      {label && (
        <label htmlFor={input.name} className={"label " + (rest.labelClassName || "")}>
          <span className="label-text">{label}</span>
        </label>
      )}

      <div className='flex gap-3'>

        {/* hidden input */}
        <input
          {...input}
          className="hidden"
          type="date"
          value={selectedDate ? selectedDate.toISOString().substr(0, 10) : ""}
          readOnly
        />

        {/* Día */}
        <select
          value={day}
          onChange={(e) => setDay(e.target.value ? +e.target.value : "")}
          className={"select flex-1 "
            + (meta && meta.error && meta.touched ? " input-error invalid-shadow " : "")
            + (rest.narrow ? " px-1 " : "")
            + (rest.inputClassName || "")
          }
          disabled={rest.readOnly || rest.disabled}
        >
          <option value="">{empty || "Día"}</option>
          {[...Array(31)].map((_, i) => (
            <option key={i + 1} value={i + 1}>{i + 1}</option>
          ))}
        </select>

        {/* Mes */}
        <select
          value={month}
          onChange={(e) => setMonth(e.target.value !== "" ? +e.target.value : "")}
          className={"select flex-1 "
            + (meta && meta.error && meta.touched ? " input-error invalid-shadow " : "")
            + (rest.narrow ? " px-1 " : "")
            + (rest.inputClassName || "")
          }
          disabled={rest.readOnly || rest.disabled}
        >
          <option value="">{empty || "Mes"}</option>
          {months_arr.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>

        {/* Año */}
        <select
          value={year}
          onChange={(e) => setYear(e.target.value ? +e.target.value : "")}
          className={"select flex-1 "
            + (meta && meta.error && meta.touched ? " input-error invalid-shadow " : "")
            + (rest.narrow ? " px-1 " : "")
            + (rest.inputClassName || "")
          }
          disabled={rest.readOnly || rest.disabled}
        >
          <option value="">{empty || "Año"}</option>
          {years.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>

      {invalidDate && (
        <label className="label">
          <span className="label-text-alt invalid-feedback">Fecha no válida</span>
        </label>
      )}

{/* <pre>
  {JSON.stringify({err:meta.error}, null, 2)}
</pre> */}

      {meta.error && (
        <label className="label">
          <span className="text-red-500 label-text-alt invalid-feedback">
            {meta.error}
          </span>
        </label>
      )}
    </div>
  );
}

export default BirthDateInput;